module.exports = __webpack_public_path__ + "img/navbarTggl.1ecc07cf.svg";